import { useT } from "@/shared/i18n/useT";
import { DateField } from "@/shared/ui/DateField";
import { Field, describedBy } from "@/shared/ui/Field";

interface DateFieldBinding {
  value: string | null;
  onChange: (value: string | null) => void;
  onBlur: () => void;
}

interface ProjectDateFieldsProps {
  /** The form fields (react-hook-form's useController(...).field). */
  startsOn: DateFieldBinding;
  dueOn: DateFieldBinding;
  startError?: string;
  dueError?: string;
  disabled?: boolean;
}

/** A project's start and end dates, side by side. */
export function ProjectDateFields({
  startsOn,
  dueOn,
  startError,
  dueError,
  disabled,
}: ProjectDateFieldsProps) {
  const t = useT();
  return (
    <div className="grid grid-cols-2 gap-x-3 sm:gap-x-5">
      <Field id="project-starts" label={t("newProject.startsOn")} error={startError}>
        <DateField
          size="md"
          value={startsOn.value}
          onChange={startsOn.onChange}
          onBlur={startsOn.onBlur}
          max={dueOn.value ?? undefined}
          disabled={disabled}
          {...describedBy("project-starts", startError)}
        />
      </Field>
      <Field id="project-due" label={t("newProject.dueOn")} error={dueError}>
        <DateField
          size="md"
          value={dueOn.value}
          onChange={dueOn.onChange}
          onBlur={dueOn.onBlur}
          min={startsOn.value ?? undefined}
          disabled={disabled}
          {...describedBy("project-due", dueError)}
        />
      </Field>
    </div>
  );
}
